// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3jxS1","selected":"styles_selected__3EimV"};